<div ngbDropdown class="w-100" autoClose="outside" [placement]="'bottom'">
  <button type="button" class="btn btn-primary w-100 text-justify" ngbDropdownToggle>
    {{ buttonText }} <span></span>
  </button>
  <div ngbDropdownMenu class="w-100" style="overflow-y: auto; max-height: 30vh; z-index: 100">
    <button ngbDropdownItem *ngIf="allowSelectAll">
      <lib-checkbox
        [id]="'ms-chk-selectAll'"
        [ngModel]="selectAll"
        [label]="'Select All'"
        (ngModelChange)="selectAllChanged($event)"></lib-checkbox>
    </button>
    <button ngbDropdownItem *ngFor="let opt of opts; let i = index">
      <lib-checkbox
        [disabled]="disableCheckbox(opt.value)"
        [id]="'ms-chk-' + i"
        [ngModel]="opt.selected"
        (ngModelChange)="valueChanged($event, opt.value)"
        [label]="opt.text"></lib-checkbox>
    </button>
  </div>
</div>
